import styled from '@emotion/styled';
import Select from 'components/Inputs/Select';

export const ViewSelect = styled(Select)`
  min-width: 200px;
`;
